export default __webpack_public_path__ + "static/media/892.97a94d1c.gif";